export default __webpack_public_path__ + "hero-next-768-4bb88895bd6c245d94c14fc1cd648c5b.bundle.webp";